import React, { cloneElement, isValidElement } from 'react';
import styles from '../styles.module.css';
import { Blog, brand, categoryType, ResponseType, ServiceSubCategory, Tags } from '@/commonTypes';
import SearchFilters from '../SearchFilters';
import PageCard from '@/components/general/PageCard';
import MainIcons from '@/icons/main';
import { lightBg, lightBgIcon } from '@/functions/formats';
import MostSearchedItem from './MostSearchedItem';
import AppLink from '@/components/common/AppLink';
import { useSearchParams } from 'next/navigation';
import SearchSections from '../SearchSections';
export default function SearchContentInside({
  tags,
  // blogs,
  // brands,
  // services,
  totalCount,
  searchKey,
  categories,
  activeMenu,
}: {
  tags?: Tags[];
  // blogs?: ResponseType<Blog>;
  // services?: ResponseType<ServiceSubCategory>;
  // brands?: ResponseType<brand>;
  totalCount?: number;
  searchKey: string;
  categories?: any;
  activeMenu?: string | number;
}) {
  const searchParams = useSearchParams();
  const searchValue = searchParams.get(searchKey);
  const menuList = [
    { id: 1, title: 'همهٔ خدمات', href: '/allServices', icon: <MainIcons.ServiceIcon /> },
    { id: 2, title: 'برند‌های خودرو', href: '/brands', icon: <MainIcons.GlobeIcon /> },
    { id: 3, title: 'بلاگ کارا', href: '/blogs', icon: <MainIcons.documentIcon /> },
  ];
  return (
    <div className={`${styles.content}`}>
      <div className={`${styles.dataContent}`}>
        <SearchFilters className={`${styles.filterContainer}`}>
          <div className={styles.resultText}>
            <span style={{ color: 'var(--text-color)', fontWeight: 'bold' }}>{totalCount}</span>{' '}
            نتیجه{' '}
            {searchValue && (
              <>
                برای «<span className={styles.searchValue}>{searchValue}</span>»
              </>
            )}
          </div>
        </SearchFilters>
        <SearchSections categories={categories} activeMenu={activeMenu} />
      </div>
      <div className={`${styles.side}`}>
        <PageCard
          backgroundIcon={lightBg(0)}
          icon={<MainIcons.SampleIcon fill={lightBgIcon(0)} />}
          title="جستجوهای داغ این هفته"
        >
          {tags?.map((item, index) => (
            <MostSearchedItem item={item} key={index} index={index} searchKey={searchKey} />
          ))}
        </PageCard>

        <PageCard noIconWidth={true} title="پیمایش‌های سریع" className={`${styles.menuList}`}>
          {menuList?.map((item, index) => (
            <AppLink key={index} title={item?.title} href={item?.href}>
              <PageCard
                className={`${styles.menuItem}`}
                title={item?.title}
                backgroundIcon={lightBg(index)}
                icon={
                  <>
                    {isValidElement(item.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
                      ? cloneElement(item?.icon, {
                          fill: lightBgIcon(index),
                          width: `${'16px'}`,
                          height: `${'16px'}`,
                        })
                      : item?.icon}
                  </>
                }
                aside={
                  <MainIcons.arrowIcon
                    className={`rotateIcon-rtl`}
                    width="15px"
                    height="15px"
                    fill="var(--text-mut)"
                  />
                }
              />
            </AppLink>
          ))}
        </PageCard>
      </div>
    </div>
  );
}
